import React, { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import AllTransfer from "./AllTransfer";
import { pendingTransactions, transactionHistory, userProfile } from "../../utils/Api";
// import authDashHelper from "../../utils/AuthDashHelper";

const Transaction = () => {

    const navigate = useNavigate();
    const [incomplete, setIncomplete] = useState([])
    const [data, setData] = useState([])
    const [loading, setLoading] = useState(false)

    const verifyKyc = async () => {
        let res = await userProfile();
        if (res.code === "200") {
            if (res?.data.is_digital_Id_verified !== "approved") {
                navigate(`/dashboard`);
            }
            let list = [];
            const history = await transactionHistory();
            if (history.code === "200") {
                list = history?.data?.data;
            }
            const pendHistory = await pendingTransactions();
            if (pendHistory.code === "200") {
                // Sort incomplete transactions by date (newest first)
                const sortedIncomplete = pendHistory?.data?.sort((a, b) => {
                    return new Date(b.updated_at || b.date) - new Date(a.updated_at || a.date);
                });
                setIncomplete(sortedIncomplete);
                list = [...list, ...pendHistory?.data];
            }
            if (list.length > 0) {
                list.sort((a, b) => {
                    return new Date(b.updated_at) - new Date(a.updated_at);
                })
            }

            setData(list)
            setLoading(false)

            let local = { ...res?.data }
            sessionStorage.removeItem("remi-user-dt")
            sessionStorage.setItem("remi-user-dt", JSON.stringify(local));
            return true;
        } else {
            setLoading(false)
            navigate('/dashboard');
        }
    }

    useEffect(() => {
        setLoading(true);
        verifyKyc();
    }, [])

    return (
        <>
            {!loading ? (
                <>
                    <section className="transfer-history-section">
                        <div className="form-head mb-4">
                            <h2 className="text-black font-w600 mb-0"><b>Transaction History</b></h2>
                        </div>
                        <div className="transaction-progress">

                            <Tabs defaultActiveKey="AllTransaction" id="uncontrolled-tab-example" className="mb-3 tarnsfer-tabs">
                                <Tab eventKey="AllTransaction" title="All Transactions">
                                    <AllTransfer status={"all"} data={data} />
                                </Tab>
                                <Tab eventKey="Pending" title="Pending">
                                    <AllTransfer status={"pending"} data={data} />
                                </Tab>
                                <Tab eventKey="Completed" title="Completed">
                                    <AllTransfer status={"completed"} data={data} />
                                </Tab>
                                <Tab eventKey="Cancelled" title="Cancelled">
                                    <AllTransfer status={"cancelled"} data={data} />
                                </Tab>
                                <Tab eventKey="Incomplete" title="Incomplete">
                                    <AllTransfer status={"Incomplete"} data={incomplete} />
                                </Tab>
                            </Tabs>
                        </div>
                    </section>
                </>
            ) : (
                <>
                    <div className="loader-overly">
                        <div className="loader" >
                        </div>
                    </div>
                </>
            )
            }

            {loading ? <>
                <div className="loader-overly">
                    <div className="loader" >
                    </div>
                </div>
            </> : <></>}
        </>
    )
}

export default Transaction;